import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import NotificationPage from "./notificationModal/NotificationPage"
import { Avatar, Box, Toolbar, Typography, Menu, MenuItem } from "@mui/material"
import { styled } from "@mui/material/styles"
import MuiAppBar from "@mui/material/AppBar"
import * as Style from "./style"
import { useAppSelector } from "../../app/hooks"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useAppDispatch } from "../../app/store"

import { Button } from "react-bootstrap"

import LogoutConfirm from "../Navbar/logout"

import LogoPhone from "../../images/logo-home.svg"

import chat from "../../images/chat.svg"

const drawerWidth = 300

interface typeprops {
  open: any
  theme: any
}
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }: typeprops) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...((open as any) && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

const CustomerHeader = ({
  open,
  position,
  handleDrawerOpen,
  theme,
}: {
  open: boolean
  position: string
  theme: string
  handleDrawerOpen: () => void
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { id } = useParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const token = useAppSelector((state: any) => state.auth.token)
  const [segamentPath, setSegamentPath] = useState()
  const [logoutModal, setLogoutModal] = React.useState(false)
  const handleLogoutOpen = () => setLogoutModal(true)
  const handlelogoutClose = () => setLogoutModal(false)

  const userDetails: any = useAppSelector((state) => state.auth)

  const navigate = useNavigate()

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const lastPathSegment = window.location.pathname
      .split("/")
      .filter((segment: any) => segment !== "")
      .pop()

    if (lastPathSegment !== undefined) {
      const capitalizedLastPathSegment =
        lastPathSegment.charAt(0).toUpperCase() + lastPathSegment.slice(1)
      setSegamentPath(capitalizedLastPathSegment as any)
    }
  }, [window.location.pathname])

  //  remove - on path
  const updatedSegment = (segamentPath as any)?.replace("-", " ")

  const logoutButton = () => {
    handleLogoutOpen()
  }

  const viewProfilehandle = () => {
    navigate("/dashboard/myaccount")
    handleClose()
  }

  const handleChat = () => {
    navigate(`/dashboard/help-center`)
  }

  return (
    <Style.Header>
      <AppBar
        position={position as any}
        open={open as boolean}
        style={{ boxShadow: "0px 4px 25px 0px rgba(0, 0, 0, 0.23)" }}
        theme={"" as any}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            background: "pink?.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                background: "#F475A4",
                height: "64px",
                width: "65px",
                marginLeft: -3,

                "@media (max-width:600px)": {
                  height: "56px",
                  width: "65px",
                },
                ...(open && { display: "none" }),
              }}
            >
              <Box
                ml={0}
                sx={{
                  img: { maxWidth: "40px" },
                  cursor: "pointer",
                  borderRadius: "10px",
                  marginLeft: "10px",
                  marginTop: "10px",
                  "@media (max-width:600px)": {
                    marginLeft: "15px",
                    marginTop: "5px",
                  },
                }}
                onClick={() => navigate("/dashboard")}
              >
                <img
                  src={LogoPhone}
                  alt="LOGO"
                  title="home"
                  style={{ background: "#F475A4" }}
                  className="img-fluid rounded "
                />
              </Box>{" "}
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontWeight: "700",
                fontSize: "24px",
                marginLeft: open ? "0px" : "10px",
                "@media (max-width:900px)": {
                  fontSize: "16px",
                },
                "@media (max-width:575px)": {
                  fontSize: "14px",
                },
              }}
            >
              {!id ? (
                <>
                  {updatedSegment === "Dashboard"
                    ? "Overview"
                    : updatedSegment == "All"
                    ? "Booking History"
                    : updatedSegment == "Completed"
                    ? "Booking History"
                     : updatedSegment == "Declined"
                    ? "Booking History"
                     : updatedSegment == "Rating reviews"
                    ? "Ratings & Reviews"
                    : updatedSegment == "Myaccount"
                    ? "My Account"
                    : updatedSegment == "Booking completed"
                    ? "Booking Completed"
                     : updatedSegment == "Create booking"
                    ? "Create Booking"
                    : updatedSegment == "My bookings"
                    ? "My Bookings"
                     : updatedSegment == "Booking history"
                    ? "Booking History"
                     : updatedSegment == "Edit bookings"
                    ? "Edit Booking"
                     : updatedSegment == "Booking overview"
                    ? "Booking Overview"
                     : updatedSegment == "Features"
                    ? "Services"
                    : window.location.pathname.includes("pending-payments")
                    ? "Pending Payment"
                    : id == updatedSegment
                    ? "Booking History"

                    : updatedSegment}
                </>
              ) : (
                "Booking Details"
              )}
              <Typography
                variant="body2"
                fontWeight="300"
                sx={{
                  "@media (max-width:600px)": {
                    fontSize: "9px",
                  },
                }}
              >
                Welcome {userDetails?.user?.name}
              </Typography>
            </Typography>
          </Box>
          <Box
            display="flex !important"
            sx={{ cursor: "pointer", gap: "5px" }}
            alignItems="center"
            className=""
          >
            <Button onClick={handleChat} className="notification-btn1">
              <img src={chat} alt="message" />
            </Button>

            <div className="">
              <NotificationPage />
            </div>

            <Avatar
              style={{ display: "flex !important" }}
              className=""
              src={userDetails?.user?.profilePic}
              onClick={handleClick}
              alt="Profile Picture"
            />

            <Box ml={1} style={{ cursor: "pointer" }}>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={viewProfilehandle}>My Profile</MenuItem>
                <MenuItem onClick={logoutButton}>Logout</MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <LogoutConfirm
        logoutModal={logoutModal as any}
        handleClose={handlelogoutClose}
      />
    </Style.Header>
  )
}

export default CustomerHeader

CustomerHeader.propTypes = {
  open: PropTypes.bool.isRequired,
  position: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
}
